import axios from 'axios';
import {
	Message
} from 'element-ui';
import qs from "qs";
import jsonp from 'jsonp';

function utf8ToBase64(str) {
	return window.btoa(unescape(encodeURIComponent(str)));
}
// console.log( process.env.BASE_API,'BASE_API')
const service = axios.create({
	baseURL: process.env.BASE_API,
	timeout: 30 * 60 * 1000,
	headers: {
		'Content-Type': 'application/json;charset=UTF-8'
	}
});

service.interceptors.request.use(config => {
	//config.body = JSON.stringify(config.data);
	if(!!sessionStorage.getItem('token')) {
		config['headers']['token'] = sessionStorage.getItem('token')
	}
	return config;
}, error => {
	Promise.reject(error);
})

// respone拦截器
service.interceptors.response.use(
	response => {
		/**
		 * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
		 * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
		 */
		var res = response.data;
		if(res.code == "403") {
			sessionStorage.clear();
			window.location.reload();
		} else if(res.code == 0) {
			return response.data;
		} else {
			Message({
				message: res.message,
				type: 'error',
				duration: 5 * 1000
			});
			return Promise.reject();
		}
	},
	error => {
		if(error.response.status == 403) {
			sessionStorage.clear();
			window.location.reload();
		}
		Message({
			message: error,
			type: 'error',
			duration: 5 * 1000
		});
		return Promise.reject(error);
	}
)

const service2 = axios.create({
	baseURL: process.env.BASE_API,
	timeout: 30 * 60 * 1000,
	headers: {
		"Content-Type": "multipart/form-data"
	}
});

service2.interceptors.request.use(config => {
	//config.body = JSON.stringify(config.data);
	if(!!sessionStorage.getItem('token')) {
		config['headers']['token'] = sessionStorage.getItem('token')
	}
	return config;
}, error => {
	Promise.reject(error);
})

// respone拦截器
service2.interceptors.response.use(
	response => {
		/**
		 * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
		 * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
		 */
		var res = response.data;
		if(res.code == "403") {
			sessionStorage.clear();
			window.location.reload();
		} else if(res.code == 0) {
			return response.data;
		} else {
			Message({
				message: res.message,
				type: 'error',
				duration: 5 * 1000
			});
			return Promise.reject();
		}
	},
	error => {
		Message({
			message: error,
			type: 'error',
			duration: 5 * 1000
		});
		return Promise.reject(error);
	}
)

export const login = params => {
	return service({
		url: '/dataportal/manager/login/login',
		method: "post",
		data: params
	});
};

export const loginSSO = params => {
	return service({
		url: '/dataportal/manager/login/sso',
		method: "post",
		data: params
	});
};
export const loginOut = params => {
	return service({
		url: '/dataportal/manager/login/loginOut',
		method: "post",
		data: params
	});
};

export const getUserInfoList = params => {
	return service({
		url: '/dataportal/manager/userInfo/getUserInfoList',
		method: "post",
		data: params
	});
};

export const updateUserInfo = params => {
	return service({
		url: '/dataportal/manager/userInfo/updateUserInfo',
		method: "post",
		data: params
	});
};

export const addUserInfo = params => {
	return service({
		url: '/dataportal/manager/userInfo/addUserInfo',
		method: "post",
		data: params
	});
};
export const addUserRole = params => {
	return service({
		url: '/dataportal/manager/userInfo/addUserRole',
		method: "post",
		data: params
	});
};

export const getUserInfoByOppositeRoleList = params => {
	return service({
		url: '/dataportal/manager/userInfo/getUserInfoByOppositeRoleList',
		method: "post",
		data: params
	});
};
export const getUserInfoByRoleList = params => {
	return service({
		url: '/dataportal/manager/userInfo/getUserInfoByRoleList',
		method: "post",
		data: params
	});
};

export const getRoleInfoList = params => {
	return service({
		url: '/dataportal/manager/roleInfo/getRoleInfoList',
		method: "post",
		data: params
	});
};

export const addRoleInfo = params => {
	return service({
		url: '/dataportal/manager/roleInfo/addRoleInfo',
		method: "post",
		data: params
	});
};

export const updateRoleInfo = params => {
	return service({
		url: '/dataportal/manager/roleInfo/updateRoleInfo',
		method: "post",
		data: params
	});
};
export const addDataBaseByRole = params => {
	return service({
		url: '/dataportal/manager/roleInfo/addDataBaseByRole',
		method: "post",
		data: params
	});
};

export const getSelectByOppositeRoleList = params => {
	return service({
		url: '/dataportal/manager/select/getSelectByOppositeRoleList',
		method: "post",
		data: params
	});
};
export const getSelectByRoleList = params => {
	return service({
		url: '/dataportal/manager/select/getSelectByRoleList',
		method: "post",
		data: params
	});
};
export const getSelectColumnList = params => {
	return service({
		url: '/dataportal/manager/select/getSelectColumnList',
		method: "post",
		data: params
	});
};
export const getBehaviorListt = params => {
	return service({
		url: '/dataportal/manager/behaviorLog/getBehaviorList',
		method: "post",
		data: params
	});
};
export const selectBysTableName = params => {
	return service({
		url: '/dataportal/manager/selectColumn/selectBysTableName',
		method: "post",
		data: params
	});
};

export const addDatabaseInfo = params => {
	return service({
		url: '/dataportal/manager/databaseInfo/addDatabaseInfo',
		method: "post",
		data: params
	});
};
export const modifyDatabaseInfo = params => {
	return service({
		url: '/dataportal/manager/databaseInfo/modifyDatabaseInfo',
		method: "post",
		data: params
	});
};
export const getDatabaseInfoList = params => {
	return service({
		url: '/dataportal/manager/databaseInfo/getDatabaseInfoList',
		method: "post",
		data: params
	});
};
export const getSelectViewList = params => {
	return service({
		url: '/dataportal/manager/selectView/getSelectViewList',
		method: "post",
		data: params
	});
};
export const addSelectView = params => {
	return service({
		url: '/dataportal/manager/selectView/addSelectView',
		method: "post",
		data: params
	});
};
export const updateSelectView = params => {
	return service({
		url: '/dataportal/manager/selectView/updateSelectView',
		method: "post",
		data: params
	});
};
export const addDownloadExport = params => {
	if(params.extBody&&params.extBody===1){
		params.extBody = utf8ToBase64(JSON.stringify(params));
		delete params.sSelectFilter;
		delete params.sSelectFieldName;
	}
	return service({
		url: '/dataportal/manager/downloadExport/addDownloadExport',
		method: "post",
		data: params
	});
};
export const getDownloadExportList = params => {
	return service({
		url: '/dataportal/manager/downloadExport/getDownloadExportList',
		method: "post",
		data: params
	});
};
export const getSchemaNameList = params => {
	return service({
		url: '/dataportal/manager/select/getSchemaNameList',
		method: "post",
		data: params
	});
};


export const getFormItemsList = params => {
	return service({
		url: '/dataportal/manager/dynamicInfo/getSelect',
		method: "post",
		data: params
	});
};

export const getOptionByPermission2 = params => {
	return service({
		url: '/dataportal/manager/dynamicInfo/getOptionByPermission2',
		method: "post",
		data: params
	});
};


export const getDynamicSQL = params => {
	if(params.extBody&&params.extBody===1){
		params.extBody = utf8ToBase64(JSON.stringify(params));
		delete params.sSelectFilter;
		delete params.sSelectFieldName;
	}
	return service({
		url: '/dataportal/manager/dynamicInfo/getDynamicSQL',
		method: "post",
		data: params
	});
};

export const getReport = params => {
	return service({
		url: '/dataportal/manager/dynamicInfo/getReport',
		method: "get",
		data: params
	});
};
export const getReportColumns = params => {
	return service({
		url: '/dataportal/manager/dynamicInfo/getReportColumns',
		method: "post",
		data: params
	});
};
export const getSelectList = params => {
	return service({
		url: '/dataportal/manager/select/getSelectList',
		method: "post",
		data: params
	});
};
export const addSelect = params => {
	return service({
		url: '/dataportal/manager/select/addSelect',
		method: "post",
		data: params
	});
};

export const getTableRelevanceList = params => {
	return service({
		url: '/dataportal/manager/tableRelevance/getTableRelevanceList',
		method: "post",
		data: params
	});
};

export const addTableRelevance = params => {
	return service({
		url: '/dataportal/manager/tableRelevance/addTableRelevance',
		method: "post",
		data: params
	});
};
export const getTableRelevanceListBySelectList = params => {
	return service({
		url: '/dataportal/manager/tableRelevance/getTableRelevanceListBySelectList',
		method: "post",
		data: params
	});
};

export const getDynamicColumnList = params => {
	return service({
		url: '/dataportal/manager/dynamicInfo/getDynamicColumnList',
		method: "post",
		data: params
	});
};

export const getSelectSecondTableList = params => {
	return service({
		url: '/dataportal/manager/select/getSelectSecondTableList',
		method: "post",
		data: params
	});
};

export const getSelectThirdTableList = params => {
	return service({
		url: '/dataportal/manager/select/getSelectThirdTableList',
		method: "post",
		data: params
	});
};

export const updateSelect = params => {
	return service({
		url: '/dataportal/manager/select/updateSelect',
		method: "post",
		data: params
	});
};
export const updateTableRelevance = params => {
	return service({
		url: '/dataportal/manager/tableRelevance/updateTableRelevance',
		method: "post",
		data: params
	});
};

export const deleteTableRelevance = params => {
	return service({
		url: '/dataportal/manager/tableRelevance/deleteTableRelevance',
		method: "post",
		data: params
	});
};
export const deleteSelect = params => {
	return service({
		url: '/dataportal/manager/select/deleteSelect',
		method: "post",
		data: params
	});
};

export const reloadDownloadExport = params => {
	return service({
		url: '/dataportal/manager/downloadExport/reloadDownloadExport',
		method: "post",
		data: params
	});
};

export const updateUserPwd = params => {
	return service({
		url: '/dataportal/manager/userInfo/updateUserPwd',
		method: "post",
		data: params
	});
};

export const simpleDownloadExport = params => {
	return service({
		url: '/dataportal/manager/downloadExport/simpleDownloadExport',
		method: "post",
		data: params
	});
};

export const deleteSelectView = params => {
	return service({
		url: '/dataportal/manager/selectView/deleteSelectView',
		method: "post",
		data: params
	});
};
export const updateFavorite = params => {
	return service({
		url: '/dataportal/manager/downloadExport/updateFavorite',
		method: "post",
		data: params
	});
};
export const selectDynamic = params => {
	return service({
		url: '/dataportal/manager/dynamicInfo/selectDynamic',
		method: "post",
		data: params
	});
};
export const addProcedure = params => {
	return service({
		url: '/dataportal/manager/select/addProcedure',
		method: "post",
		data: params
	});
};
export const updateProcedure = params => {
	return service({
		url: '/dataportal/manager/select/updateProcedure',
		method: "post",
		data: params
	});
};

export const selectPSpConditionList = params => {
	return service({
		url: '/dataportal/manager/select/selectPSpConditionList',
		method: "post",
		data: params
	});
};

export const selectDynamicSP = params => {
	return service({
		url: '/dataportal/manager/dynamicInfo/selectDynamicSP',
		method: "post",
		data: params
	});
};

export const getLock = params => {
	return service({
		url: '/dataportal/manager/dynamicInfo/getLock',
		method: "post",
		data: params
	});
};

export const addRoleAuthority = params => {
	return service({
		url: '/dataportal/manager/roleInfo/addRoleAuthority',
		method: "post",
		data: params
	});
};

export const updateDetailRoleInfo = params => {
	return service({
		url: '/dataportal/manager/roleInfo/updateDetailRoleInfo',
		method: "post",
		data: params
	});
};

export const getRoleAuthorityList = params => {
	return service({
		url: '/dataportal/manager/roleInfo/getRoleAuthorityList',
		method: "post",
		data: params
	});
};

export const selectUploadTemplatePage = params => {
	return service({
		url: '/dataportal/manager/uploadTemplate/selectUploadTemplatePage',
		method: "post",
		data: params
	});
};

export const getUploadTemplateByRoleListPage = params => {
	return service({
		url: '/dataportal/manager/uploadTemplate/getUploadTemplateByRoleListPage',
		method: "post",
		data: params
	});
};

export const selectTemplateFieldList = params => {
	return service({
		url: '/dataportal/manager/uploadTemplate/selectTemplateFieldList',
		method: "post",
		data: params
	});
};

export const saveTemplate = params => {
	return service({
		url: '/dataportal/manager/uploadTemplate/saveTemplate',
		method: "post",
		data: params
	});
};

export const modifyTemplate = params => {
	return service({
		url: '/dataportal/manager/uploadTemplate/modifyTemplate',
		method: "post",
		data: params
	});
};

export const selectTemplateLogPage = params => {
	return service({
		url: '/dataportal/manager/uploadTemplate/selectTemplateLogPage',
		method: "post",
		data: params
	});
};

export const importTemplate = params => {
	return service2({
		url: '/dataportal/manager/uploadTemplate/importTemplate',
		method: 'post',
		data: params
	})
};

export const importWellness = params => {
	return service2({
		url: '/dataportal/manager/uploadTemplate/importWellness',
		method: 'post',
		data: params
	})
};

export const selectRoleVisitAuthorityBynRoleId = params => {
	return service({
		url: '/dataportal/manager/roleInfo/selectRoleVisitAuthorityBynRoleId',
		method: 'post',
		data: params
	})
};
export const selectRoleValueAuthorityBynSelectId = params => {
	return service({
		url: '/dataportal/manager/roleInfo/selectRoleValueAuthorityBynSelectId',
		method: 'post',
		data: params
	})
};
export const selectRoleFieldAuthorityBynSelectId = params => {
	return service({
		url: '/dataportal/manager/select/selectRoleFieldAuthorityBynSelectId',
		method: 'post',
		data: params
	})
};

export const delRoleValueAuthority = params => {
	return service({
		url: '/dataportal/manager/roleInfo/delRoleValueAuthority',
		method: 'post',
		data: params
	})
};
export const delFieldAuthority = params => {
	return service({
		url: '/dataportal/manager/roleInfo/delFieldAuthority',
		method: 'post',
		data: params
	})
};

export const addRoleValueAuthority = params => {
	return service({
		url: '/dataportal/manager/roleInfo/addRoleValueAuthority',
		method: 'post',
		data: params
	})
};
export const addFieldAuthority = params => {
	return service({
		url: '/dataportal/manager/roleInfo/addFieldAuthority',
		method: 'post',
		data: params
	})
};
export const selectColumnValueBynSelectId = params => {
	return service({
		url: '/dataportal/manager/roleInfo/selectColumnValueBynSelectId',
		method: 'post',
		data: params
	})
};

export const getTemplateByOppsiteRoleList = params => {
	return service({
		url: '/dataportal/manager/uploadTemplate/getTemplateByOppositeRoleList',
		method: 'post',
		data: params
	})
};

export const getTemplateByRoleList = params => {
	return service({
		url: '/dataportal/manager/uploadTemplate/getTemplateByRoleList',
		method: 'post',
		data: params
	})
};

export const addRoleTemplate = params => {
	return service({
		url: '/dataportal/manager/roleInfo/addRoleTemplate',
		method: 'post',
		data: params
	})
};


export const getUploadResultDetail = params => {
	return service({
		url: '/dataportal/manager/uploadTemplate/getUploadResultList',
		method: 'post',
		data: params
	})
};

export const selectExColumnValueBynSelectId = params => {
	return service({
		url: '/dataportal/manager/roleInfo/selectExColumnValueBynSelectId',
		method: 'post',
		data: params
	})
};




export const addCurrencyCheckRule = params => {
	return service({
		url: '/dataportal/manager/currencyCheckRule/addCurrencyCheckRule',
		method: 'post',
		data: params
	})
};
export const deleteCurrencyCheckRule = params => {
	return service({
		url: '/dataportal/manager/currencyCheckRule/deleteCurrencyCheckRule',
		method: 'post',
		data: params
	})
};

export const getCurrencyCheckRulePage = params => {
	return service({
		url: '/dataportal/manager/currencyCheckRule/getCurrencyCheckRulePage',
		method: 'post',
		data: params
	})
};

export const modifyCurrencyCheckRule = params => {
	return service({
		url: '/dataportal/manager/currencyCheckRule/modifyCurrencyCheckRule',
		method: 'post',
		data: params
	})
};




// WEBPACK FOOTER //
// ./src/api/api.js